/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-05-21 18:50:41
 * @LastEditTime: 2019-08-12 16:00:05
 * @LastEditors: Please set LastEditors
 */
import axios from 'axios';
import qs from 'qs';

// 定义一个混入对象
const searchMixin = {
  props: ['disabled'],
  data() {
    return {
      appIdOptions: [],
      pageIdOptions: [],
      slotIdOptions: [],
      typeOptions: [{
        label: '媒体',
        value: 'appId'
      }, {
        label: '页面',
        value: 'pageId'
      }, {
        label: '广告位',
        value: 'slotId'
      }],
      clientType: '',
      type: 'pageId',
      appId: '',
      pageId: '',
      slotId: ''
    };
  },
  mounted() {
    this.$bus.$on('clientChange', val => {
      this.clientType = val;
      this.initType();
    });

    if (this.$bus.DATA.clientType) {
      this.clientType = this.$bus.DATA.clientType;
      this.initType();
    }
  },
  methods: {
    initType() {
      this.appId = '';
      this.pageId = '';
      this.slotId = '';
      this.fetchAppIds();
      this.fetchPageIds();
      this.fetchSlotIds();

      this.init();
    },
    fetchPageIds() {
      const query = {
        client: this.clientType,
        dataRange: this.dateRange
      };

      return axios
        .get(`/timeRatio/pageIds?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;
          const arr = [];
          data.map(item => {
            arr.push({
              label: item.key,
              value: item.key
            });
          });
          this.pageIdOptions = [{
            label: '全部页面',
            value: ''
          }].concat(arr);
        });
    },
    fetchAppIds() {
      const query = {
        client: this.clientType,
        dataRange: this.dateRange
      };

      return axios
        .get(`/timeRatio/appIds?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;
          const arr = [];
          data.map(item => {
            if (item.key) {
              arr.push({
                label: item.key,
                value: item.key
              });
            }
          });
          this.appIdOptions = [{
            label: '全部媒体',
            value: ''
          }].concat(arr);
        });
    },
    fetchSlotIds() {
      const query = {
        client: this.clientType,
        dataRange: this.dateRange
      };

      return axios
        .get(`/timeRatio/slotIds?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;
          const arr = [];
          data.map(item => {
            if (item.key) {
              arr.push({
                label: item.key,
                value: item.key
              });
            }
          });
          this.slotIdOptions = [{
            label: '全部广告位',
            value: ''
          }].concat(arr);
        });
    },
    changeType(type) {
      this.$emit('update:params', {
        clientType: this.clientType,
        dateRange: this.dateRange,
        type,
        [type]: ''
      });

      this.clear();

      this.showCharts();
    },
    changeAppId(appId) {
      this.$emit('update:params', {
        clientType: this.clientType,
        dateRange: this.dateRange,
        type: this.type,
        appId
      });

      this.clear('appId');

      this.showCharts();
    },
    setAppId(appId) {
      this.appId = appId;
      this.changeAppId(appId);
    },
    changePageId(pageId) {
      this.$emit('update:params', {
        clientType: this.clientType,
        dateRange: this.dateRange,
        type: this.type,
        pageId
      });
      this.clear('pageId');
      this.showCharts();
    },
    setPageId(pageId) {
      this.pageId = pageId;
      this.changePageId(pageId);
    },
    changeSlotId(slotId) {
      this.$emit('update:params', {
        clientType: this.clientType,
        dateRange: this.dateRange,
        type: this.type,
        slotId
      });
      this.clear('slotId');
      this.showCharts();
    },
    setSlotId(slotId) {
      this.slotId = slotId;
      this.changeSlotId(slotId);
    },
    clear(cur) {
      this.typeOptions.map(type => {
        if (type !== cur) {
          this[type] = '';
        }
      });
    },
    isVisible(name) {
      return !this.disabled || (this.disabled && this.disabled.indexOf(name) === -1);
    }
  }
};

export default searchMixin;
